import { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

const TRUST_ITEMS = [
  { icon: 'ri-award-line', value: '19+', label: 'Years of Experience' },
  { icon: 'ri-home-heart-line', value: 'Locally', label: 'Owned & Operated' },
  { icon: 'ri-vip-crown-line', value: 'Premium', label: 'Residential Specialists' },
  { icon: 'ri-shield-check-line', value: 'Fully', label: 'Licensed & Insured' },
  { icon: 'ri-star-fill', value: '35+', label: 'Five-Star Reviews' },
];

export default function TrustBar() {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useIntersectionObserver(ref, { threshold: 0.2 });

  return (
    <section ref={ref} className="bg-charcoal-900 border-b border-white/5 relative">
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-stone-500/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-8">
        <div className={`grid grid-cols-5 divide-x divide-white/8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`}>
          {TRUST_ITEMS.map((item, i) => (
            <div
              key={item.label}
              className="flex flex-col items-center text-center py-9 px-6 transition-all duration-700"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-stone-400 text-xl`} />
              </div>
              <div className="font-serif text-white text-2xl font-bold tracking-tight mb-1">{item.value}</div>
              <div className="font-sans text-stone-500 text-[11px] tracking-[0.15em] uppercase">{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-stone-500/30 to-transparent" />
    </section>
  );
}
